import Vue from 'vue'
import App from './App.vue'
import router from './router'

import './assets/scss/main.scss'
import './assets/scss/fonts.scss'

import FirebaseVue from './utils/firebase'
import './utils/directives'

Vue.use(FirebaseVue)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
